/* eslint-disable no-useless-escape */
let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{12,})");
export default string => strongRegex.test(string);



// WEBPACK FOOTER //
// ./src/utils/is-valid-password.js